<template>
  <div class="device-item subitem mb-3">
    <div class="loader-content" v-if="isLoading">
      <Loader />
    </div>
    <div class="header-content">
      <label class="legend">{{ device.deviceName }}</label>
    </div>
    <div class="body-content">
      <div class="grid-columns">
        <div class="column">
          <b-field label="Tipo de dispositivo *">
            <b-select
              placeholder="Tipo de disposiitvo"
              name="deviceType"
              v-model="device.deviceType"
              expanded
            >
              <option
                v-for="option in device.deviceTypes"
                :value="option.code"
                :key="option.code"
                :id="option.code"
              >
                {{ option.title }}
              </option>
            </b-select>
          </b-field>
        </div>
        <div class="column">
          <b-field label="Nombre de dispositivo  *">
            <b-input
              placeholder="Nombre de dispositivo"
              type="text"
              name="deviceName"
              v-model="device.deviceName"
            />
          </b-field>
        </div>
        <div class="column">
          <b-field label="Estado *">
            <b-select
              placeholder="Estado"
              expanded
              v-model="device.status"
              name="status"
            >
              <option
                v-for="option in device.statusList"
                :value="option.code"
                :key="option.code"
                :id="option.code"
              >
                {{ option.description }}
              </option>
            </b-select>
          </b-field>
        </div>
        <div
          class="column"
          v-for="(field, index) in device.dinamycFields"
          :key="field.key"
          :id="field.key"
        >
          <b-field
            :label="`${field.title}${field.required ? ' *' : ''}`"
            v-if="field.type === 'text'"
          >
            <b-input
              :placeholder="field.title"
              :type="field.type"
              :name="field.key"
              v-model="device.dinamycValueFields[index]"
            />
          </b-field>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ROUTES } from "../../../global/api_routes";
import { validator } from "../../../global/validator";
import Loader from "../../../components/Shared/Loader.vue";
export default {
  components: { Loader },
  props: {
    device: {
      type: Object,
      default: {},
    },
  },
  data: () => ({
    isLoading: false,
  }),
  watch: {
    "device.deviceType": function (id) {
      console.log(id);
      if (!id) {
        return;
      }
      this.getDeviceTypesFields(id);
    },
  },
  methods: {
    onChangeDeviceType(device) {
      console.log(device);
    },
    validate(device) {
      const rules = [
        { field: "deviceType" },
        { field: "company" },
        { field: "deviceName" },
        { field: "status" },
      ];
      const extraValues = {};
      device.dinamycFields.forEach((field, index) => {
        if (field.required) {
          rules.push({ field: field.key });
          extraValues[field.key] = device.dinamycValueFields[index];
        }
      });
      const { result } = validator({ ...device, ...extraValues }, rules);
      return !result;
    },
    getDeviceTypesFields(id) {
      this.isLoading = true;
      this.dinamycFields = [];
      this.dinamycValueFields = {};
      this.$http
        .get(ROUTES.DASHBOARD.CONFIG_DEVICES.GET_DEVICE_TYPE_FIELDS, {
          params: {
            deviceTypeId: id,
          },
        })
        .then(({ data }) => {
          if (data.code < 1 || !data.info) {
            this.device.dinamycFields = [];
            this.device.dinamycValueFields = [];
            return;
          }
          this.device.dinamycFields = JSON.parse(data.info.fields);
          this.device.dinamycFields.forEach((field) => {
            this.dinamycValueFields[field.key] = null;
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
  mounted() {},
};
</script>

<style>
.grid-columns {
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
}
.device-item {
  position: relative;
}
.device-item.subitem {
  background-color: #ffffff;
  border-radius: 5px;
  box-shadow: 0 0px 2px #333333;
}
.device-item .loader-content {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ffffffbf;
  z-index: 5;
}
</style>
